export const ProjectContents = [
  {
    id: 1,
    image: "goal.png",
    title: "Goal Organiser App",
    challenges:"Managing form state globally with Redux, and structuring a scalable component architecture.",
    inspiration:"Inspired by personal productivity tools like Notion and Todoist, with a focus on building an app to track and manage learning goals.",
    description:"A personal goal-tracking app where users can add and delete learning goals with a short description.",
    technology: "React, TypeScript, Redux Toolkit, CSS",

    github: "https://github.com/thatseogirl/Goal-builder",
    demo: "https://goal-organiser.netlify.app/",
  },
  {
    id: 2,
    image: "Real-Estate.png",
    title: "Real Estate App",
    challenges:
      "Handling user authentication, ensuring the scalability of the search functionality, and managing a large number of listings with optimal performance.",
    inspiration:
      "Inspired by modern real estate platforms like funda and orange-homes, aiming to make home buying/selling seamless for users.",
    description:
      "Users can view all listings, create their own, edit or delete their listings, and search for houses.",
    technology: "React, React Router, React Hooks, Styled Components, Redux",
    github: "https://github.com/thatseogirl/real-estate-app",
    demo: "https://tobi-real-estate-app.netlify.app/",
  },

  {
    id: 3,
    image: "questionnaire.png",
    title: "Insurance questionnaire",
    challenges:
      "Simplifying complex insurance questions for a better user experience and integrating form validation to ensure data accuracy.",
    inspiration:
      "To make insurance applications user-friendly by breaking down complicated processes into digestible steps.",
    description:
      "In this questionnaire we would like have an understanding of what/who you want to insure.",
    technology:
      "React, React Memo, React Hooks, Styled Components, CSS Animations,",
    github: "https://github.com/thatseogirl/insurance-questionnaire",
    demo: "https://questionnaire-tobi.netlify.app/",
  },

  {
    id: 4,
    image: "ecommerce.png",
    title: "E commerce Landing page",
    challenges:
      "Implementing a dynamic cart feature and creating a responsive design that adapts to various devices.",
    inspiration:
      "Inspired by popular e-commerce platforms to create a sleek and intuitive shopping experience.",
    description:
      "It allows users to add product to cart, increment values and decrement values,and also to view various images on a product.",
    technology: "React, React hooks, CSS",
    github: "https://github.com/thatseogirl/E-commerce-Landing-Page",
    demo: "https://tobi-e-commerce.netlify.app/",
  },

  {
    id: 5,
    image: "calculator.png",
    title: "Calculator App",
    challenges:
      "Developing accurate mathematical operations and handling edge cases like dividing by zero or resetting the calculator seamlessly.",
    inspiration:
      "To create a reliable tool for quick calculations, emphasizing usability and performance.",
    description:
      "It allows users to sum up values, multiply, delete, divide, reset, and subtract values.",
    technology: "React, Redux, CSS, Unit Test",
    github: "https://github.com/thatseogirl/calculator-app?tab=readme-ov-file",
    demo: "https://redux-calculator-app.netlify.app/",
  },

  {
    id: 6,
    image: "restapi.png",
    title: "Country RESTAPI",
    challenges:
      "Managing API responses for large datasets and creating an intuitive way to filter and search countries.",
    inspiration:
      "Inspired by the need for a quick reference tool for geographical and cultural information.",
    description:
      "This is a country list of the world, user can view each country details and add country to cart.",
    technology: "React, React Hooks, Typescript, RESTAPI",
    github: "https://github.com/thatseogirl/is3-frontend-project",
    demo: "https://frontend-project-integrify.netlify.app/",
  },

  {
    id: 7,
    image: "dashboard.png",
    title: "Time Tracking Dashboard",
    challenges:
      "Presenting real-time stats in an easy-to-digest format and handling the toggle between daily, weekly, and monthly views.",
    inspiration:
      "Helping individuals and teams monitor productivity effectively.",
    description:
      "This is a Time tracking dashboard, it allows users to switch between stats",
    technology: "HTML, CSS, and Vanilla Javascript",
    github: "https://github.com/thatseogirl/Time-tracking-dashboard",
    demo: "https://thatseogirl.github.io/Time-tracking-dashboard/",
  },

  {
    id: 8,
    image: "tip.png",
    title: "Tip Calculator",
    challenges:
      "Calculating accurate tips per person and ensuring the app functions correctly with various input scenarios.",
    inspiration:
      "Simplifying the often-confusing task of splitting bills and tips during group meals.",
    description:
      "This is a Tip Calculator that allows users calculate their bills and tip per person.",
    technology: "HTML, CSS, and Vanilla Javascript",
    github: "https://github.com/thatseogirl/Tip-Calculator",
    demo: "https://thatseogirl.github.io/Tip-Calculator/",
  },

  // {
  //     id: 8,
  //     image: "launch.png",
  //     title: "Launch countdown timer",
  //     challenges: "",
  //     inspiration: ""
  //     description: "This is a lauch countdown timer.",
  //     technology: "HTML, CSS, Vanilla Javascript",
  //     github: "https://github.com/thatseogirl/Launch-countdown-timer",
  //     demo: "https://thatseogirl.github.io/Launch-countdown-timer/"
  // },

  {
    id: 9,
    image: "shortening.png",
    title: "Shortly URL Shortening API App.",
    challenges:
      "Optimizing API calls to shorten URLs and designing a layout that displays shortened links effectively.",
    inspiration:
      "Inspired by tools like Bitly, this project aims to streamline link-sharing in a clutter-free interface.",
    description: "This is a url shortener",
    technology: "React, React Hooks, CSS",
    github: "https://github.com/thatseogirl/url-shortening-api-landing-page",
    demo: "https://tobi-url-shortening-api.netlify.app/",
  },

  {
    id: 10,
    image: "form.png",
    title: "Registration Form",
    challenges:
      "Implementing client-side and server-side validation to ensure secure and accurate user registration.",
    inspiration:
      "Inspired by modern sign-up flows to deliver a smooth onboarding process for new users.",
    description:
      "This is a registration form that allows users to create an account and login.",
    technology: "React(Router, Hooks), SCSS",
    github: "https://github.com/thatseogirl/Registration-form",
    demo: "https://tobi-registration-form.netlify.app/",
  },

  {
    id: 11,
    image: "user.png",
    title: "Live User Filter",
    challenges:
      "Optimizing search functionality for large datasets and creating a seamless real-time filtering experience.",
    inspiration:
      "Building a tool to simplify data exploration and improve efficiency for users.",
    description:
      "This is a user filter app. Users can be searched by name, and / or location.",
    technology: "HTML, CSS, and Vanilla Javascript",
    github: "https://github.com/thatseogirl/Live-user-filter",
    demo: "https://thatseogirl.github.io/Live-user-filter/",
  },

  {
    id: 12,
    image: "airbnb.png",
    title: "Airbnb Clone",
    challenges:
      "Recreating the visual design of Airbnb while making the site responsive and accessible.",
    inspiration:
      "Inspired by Airbnb's clean and intuitive interface, aiming to replicate a similar experience.",
    description: "This is a clone of the Airbnb Landing page.",
    technology: "React, React Hooks, CSS ",
    github: "https://github.com/thatseogirl/airbnb-clone",
    demo: "https://tobi-airbnb-clone.netlify.app/",
  },

  // {
  //     id: 13,
  //     image: "portfolio.png",
  //     title: "Portfolio",
  //     description: "This is an overview of some of my Projects,you can also view all projects on my Github.",
  //     technology: "React, React Hooks, SCSS, AOS Animations,",
  //     github: "https://github.com/thatseogirl/personal-portfolio",
  //     demo: "https://thatseogirl.netlify.app/"
  // },

  {
    id: 14,
    image: "fylo.png",
    title: "Fylo dark theme website",
    challenges:
      "Balancing aesthetics with readability in a dark theme and ensuring accessibility for all users.",
    inspiration:
      "The growing popularity of dark mode interfaces in modern web design inspired this project.",
    description: "This a dark themed website.",
    technology: "React, FormYik, Yup, CSS Animations,",
    github: "https://github.com/thatseogirl/Fylo-dark-theme-website",
    demo: "https://tobi-fylo-website.netlify.app/",
  },

  // {
  //     id: 15,
  //     image: "task-tracker.png",
  //     title: "Task Tracker",
  //     description: "This a task tracker app, users can add, edit, delete task and toggle reminder.",
  //     technology: "React, React Hooks, CSS",
  //     github: "https://github.com/thatseogirl/Task-tracker",
  //     demo: "https://task-tracker-tobi.netlify.app/"
  // }
];

export const cardContents = [
  {
    id: 1,
    title: "html",
    image: "html5.png",
  },
  {
    id: 2,
    title: "css",
    image: "css.png",
  },
  {
    id: 3,
    title: "javascript",
    image: "javascript.png",
  },
  {
    id: 4,
    title: "react",
    image: "react.png",
  },
  {
    id: 5,
    title: "reduxjs",
    image: "reduxjs.png",
  },
  {
    id: 6,
    title: "nodejs",
    image: "nodejs.png",
  },
  {
    id: 7,
    title: "expressjs",
    image: "expressjs.png",
  },
  {
    id: 8,
    title: "mongodb",
    image: "mongodb.png",
  },
  {
    id: 9,
    title: "aws",
    image: "aws.png",
  },
  {
    id: 9,
    title: "terraform",
    image: "terraform.png",
  },
];
